export const DRUG_INFO_OBJECT = {
  apiParam: 'drug-info',
  id: '',
  enabled: true,
  slug: '',
  clinicIds: [],
  name: '',
  genericName: '',
  dosage: '0-0-0',
  qty: '',
  unit: '',
  timing: '',
  whatTime: '',
  appliedWhere: '',
  frequency: '',
  note: '',
}
